export default {
    data() {
        return {
            o_val: window.pageYOffset
        };
    },
    mounted() {
        this.ik_prlx();
        // window.addEventListener("touchmove", () => {
        //     let n = window.pageYOffset;
        //     this.o_val = n;
        // });
        window.addEventListener("scroll", () => {
            this.ik_prlx();

        })
        window.addEventListener("resize", () => {
            this.ik_prlx();

        })
    },
    watch: {
        o_val: {
            immediate: true,
            handler(ns, os) {
                if (ns > os) {
                    let dist = ns - os;

                } else if (ns < os) {
                    let dist = os - ns;


                }
            }
        }
    },
    methods: {
        ik_prlx(dir) {
            if (window.innerWidth <= 1023 && window.innerWidth >= 768) {
       
                let _p = document.querySelectorAll(".ik_prlx");
             
                let intensity;
                _p.forEach(p => {
                    intensity = p.getAttribute("prlx-intensity") ? parseFloat(p.getAttribute("prlx-intensity")) : 30;
                    let _d = (-(p.getBoundingClientRect().top - window.innerHeight) / intensity);
                    p.style.transform = `translateY(${_d}px)`;
               
                });
            }
        },

        clamp(min, max, val) {
            if (val < min) {
                return min;
            } else if (val > max) {
                return max;
            } else {
                return val;
            }
        }
    }
};